import * as THREE from 'three';

import { makeCanvas, makeTexture } from './canvas';

export interface ShirtPrint {
  /** Transparent canvas with the logo in white; blank until `paint` runs. */
  texture: THREE.CanvasTexture;
  /** Draws the logo as a white silhouette once its image has loaded. */
  paint(image: CanvasImageSource): void;
}

/**
 * The staff polo print: the logo knocked out in white, for a navy shirt. The
 * logo PNG is red and navy, which would vanish on navy, so its alpha is used
 * as a stencil instead.
 */
export function createShirtPrint(): ShirtPrint {
  const ctx = makeCanvas(1024, 160);
  const texture = makeTexture(ctx);
  return {
    texture,
    paint(image) {
      ctx.clearRect(0, 0, 1024, 160);
      ctx.drawImage(image, 12, 6, 1000, 146);
      ctx.globalCompositeOperation = 'source-in';
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, 1024, 160);
      ctx.globalCompositeOperation = 'source-over';
      texture.needsUpdate = true;
    },
  };
}
